import { SEVERITY_TIER_CONFIG, SeverityTier } from "../../types/severity-tier";
import styles from "./SeverityBadge.module.css";

export interface SeverityBadgeProps {
  tier: SeverityTier;
}

const TIER_CLASS: Record<SeverityTier, string> = {
  [SeverityTier.MATCH]: styles.tierMatch,
  [SeverityTier.ACCEPTABLE]: styles.tierAcceptable,
  [SeverityTier.MINOR]: styles.tierMinor,
  [SeverityTier.VARIANCE]: styles.tierVariance,
  [SeverityTier.CRITICAL]: styles.tierCritical,
  [SeverityTier.ERROR]: styles.tierError,
  [SeverityTier.SKIPPED_ZERO]: styles.tierSkippedZero,
  [SeverityTier.SKIPPED_REVERSAL]: styles.tierSkippedReversal,
  [SeverityTier.SKIPPED_REVERSAL_TYPE]: styles.tierSkippedReversal,
  [SeverityTier.SKIPPED_INTERVENTION]: styles.tierSkippedIntervention,
  [SeverityTier.SKIPPED_PRE_CONFIG]: styles.tierSkippedPreConfig,
};

export function SeverityBadge({ tier }: SeverityBadgeProps) {
  const config = SEVERITY_TIER_CONFIG[tier];

  return (
    <span className={`${styles.badge} ${TIER_CLASS[tier]}`}>
      {config.label}
    </span>
  );
}
